<template>
  <projects></projects>
</template>

<script>
import Projects from "@/components/client/Projects";
export default {
  components: {
    Projects
  }
};
</script>

<style></style>
